import $ from 'jquery';
import {} from 'slick-carousel';

function gallerySlider() {
	let $slider = $('.c-gallery-slider_slider'),
			$nav    = $('.c-gallery-slider_nav');

	$slider.slick({
		appendArrows: '.c-gallery-slider_nav-container',
		asNavFor: $nav,
		centerMode: true,
		centerPadding: '0px',
		dots: false,
		nextArrow: '<button type="button" class="c-gallery-slider_prevnext c-gallery-slider_next">Next</button>',
		prevArrow: '<button type="button" class="c-gallery-slider_prevnext c-gallery-slider_prev">Previous</button>',
		rows: 0,
		slidesToShow: 3,
		speed: 350,
		touchThreshold:100,
		variableWidth: true,
	});

	$nav.slick({
		asNavFor: $slider,
		arrows: false,
  	focusOnSelect: true,
		rows: 0,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '60px',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 5,
					centerPadding: '10px',
				}
			}
		]
	})
}

export { gallerySlider };